/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M11.111 5.5H20V4h-8.889v1.5ZM4 12.5h16V11H4v1.5Zm7.111 7H20V18h-8.889v1.5Z" />
	</SVG>
);

export default alignRight;
